import { Component, OnInit } from '@angular/core';
import { PosFloatingActionButtonService } from 'src/app/@core/services/pos-floating-action-button.service';

@Component({
  selector: 'app-replicate-information',
  templateUrl: './replicate-information.component.html',
  styleUrls: ['./replicate-information.component.sass']
})
export class ReplicateInformationComponent implements OnInit {

  constructor(private floatingService: PosFloatingActionButtonService) {
    this.floatingService.setShow(false);
    this.floatingService.addItems();
  }

  ngOnInit(): void {
  }

}
